angular.module('b2bRegistrationFlowBundle').controller('ThankYouPageController', ["$scope", "$sessionStorage", "spContactEmailSessionKey", function ($scope, $sessionStorage, spContactEmailSessionKey) {
    $scope.registeredEmail = $sessionStorage[spContactEmailSessionKey];
}]);
